import { render, staticRenderFns } from "./SupportedFeatures.vue?vue&type=template&id=30021169"
import script from "./SupportedFeatures.vue?vue&type=script&lang=js"
export * from "./SupportedFeatures.vue?vue&type=script&lang=js"
import style0 from "./SupportedFeatures.vue?vue&type=style&index=0&id=30021169&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports